"use client";

import { useState } from "react";
import Logo from "@/app/components/Logo";
import Button from "@/app/components/Button";
import MasterFileEditor from "@/app/components/MasterFileEditor";
import RequestForm from "@/app/components/RequestForm";
import ImageGenAdmin from "@/app/components/ImageGenAdmin";
import ProvincePaintEditor from "./ProvincePaintEditor";
import BattleDemo from "./BattleDemo";
import CraftDemo from "./CraftDemo";
import NpcAdmin from "./NpcAdmin";
import Encyclopedia from "./Encyclopedia";
import QueueAdmin from "./QueueAdmin";

const WORLD = "Baunheim";

type View = "menu" | "encyclopedia" | "map" | "battle-demo" | "craft-demo" | "image-gen" | "queue" | "setting" | "setting-edit" | "setting-request" | "setting-npc";

/** Baunheim のマスターデータ管理 UI の入口 */
export default function AdminMenu({ onBack }: { onBack: () => void }) {
  const [message, setMessage] = useState("");
  const [view, setView] = useState<View>("menu");

  if (view === "encyclopedia") {
    return <Encyclopedia onBack={() => setView("menu")} />;
  }

  if (view === "map") {
    return <ProvincePaintEditor onBack={() => setView("menu")} />;
  }

  if (view === "battle-demo") {
    return <BattleDemo onBack={() => setView("menu")} />;
  }

  if (view === "craft-demo") {
    return <CraftDemo onBack={() => setView("menu")} />;
  }

  if (view === "image-gen") {
    return <ImageGenAdmin onBack={() => setView("menu")} />;
  }

  if (view === "queue") {
    return <QueueAdmin onBack={() => setView("menu")} />;
  }

  if (view === "setting-edit") {
    return <MasterFileEditor world={WORLD} onBack={() => setView("setting")} />;
  }

  if (view === "setting-npc") {
    return <NpcAdmin onBack={() => setView("setting")} />;
  }

  if (view === "setting-request") {
    return <RequestForm world={WORLD} onBack={() => setView("setting")} />;
  }

  if (view === "setting") {
    return (
      <div className="panel">
        <Logo />
        <div className="menu">
          <Button onClick={() => setView("setting-edit")}>調整</Button>
          <Button onClick={() => setView("setting-request")}>依頼</Button>
          <Button onClick={() => setView("setting-npc")}>NPC</Button>
        </div>

        <div className="foot">
          <Button onClick={() => setView("menu")} inline>
            戻る
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="panel">
      <Logo />
      <div className="menu">
        <Button onClick={() => setView("setting")}>世界設定調整</Button>
        <Button onClick={() => setView("encyclopedia")}>図鑑</Button>
        <Button onClick={() => setView("map")}>MAP編集</Button>
        <Button onClick={() => setView("queue")}>依頼と進行待ち</Button>
        <Button onClick={() => setMessage("ユーザー管理は未実装です")}>ユーザー管理</Button>
        <Button onClick={() => setView("battle-demo")}>戦闘デモプレイ</Button>
        <Button onClick={() => setView("craft-demo")}>作製デモプレイ</Button>
        <Button onClick={() => setView("image-gen")}>画像生成</Button>
      </div>

      <div className="foot">
        <Button onClick={onBack} inline>
          戻る
        </Button>
      </div>

      <p className="message message-info">{message}</p>
    </div>
  );
}
